import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import {
  border,
  borderRadius,
  color,
  compose,
  flexbox,
  layout,
  LayoutProps,
  opacity,
  overflow,
  position,
  PositionProps,
  shadow,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';

type Props = LayoutProps & SpaceProps & PositionProps & TypographyProps;

export const Box = styled('div', {
  shouldForwardProp: isPropValid,
})<Props>(() =>
  compose(
    flexbox,
    space,
    border,
    borderRadius,
    color,
    layout,
    opacity,
    overflow,
    shadow,
    typography,
    position
  )
);
